import { useParams } from "react-router";
import { useState, useEffect } from "react";
import { getAccountInfoAsync } from "../../services/accountService";
import ProfileHeading from "./components/ProfileHeading";
import IncomeInformation from "./components/IncomeInformation";
import BasicInformation from "./components/BasicInformation";
import ProfileTabs from "./components/ProfileTabs";
import Contributions from "./components/Contributions";
import Taxes from "./components/Taxes";
import Documents from "./components/Documents";
import Compliances from "./components/Compliances/index";
import AccountPlan from "./components/AccountPlan";
import Identifications from "./components/Identifications";
import AccountReferrals from "./components/AccountReferrals";
import Emails from "./components/Emails";
import Others from "./components/Others";
import ProfileNavigation from "./components/ProfileNavigation";

const Profile = () => {
  const { id } = useParams();

  const [account, setAccount] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchAccount = async () => {
      setIsLoading(true);
      const result = await getAccountInfoAsync(id);
      if (result === null) window.location = "/404";

      if (mounted) {
        setAccount(result);
        setIsLoading(false);
      }
    };

    fetchAccount(id);

    return () => {
      mounted = false;
    };
  }, [id, refresh]);

  const [documentParams, setDocumentParams] = useState({
    search_query: "",
    current_page: 1,
    page_size: 5,
    sort_column: { path: "uploaded_on", order: "desc" },
  });

  const handleDocumentsRefresh = () => {
    const params = { ...documentParams };
    setDocumentParams(params);
  };

  const tabs = [
    {
      id: 1,
      title: "Basic Info",
      content: (
        <BasicInformation
          id={id}
          data={account}
          isLoading={isLoading}
          onRefresh={() => setRefresh(!refresh)}
        />
      ),
    },
    {
      id: 2,
      title: "Compliances",
      content: <Compliances id={id} onRefresh={handleDocumentsRefresh} />,
    },
    {
      id: 3,
      title: "Contributions",
      content: <Contributions id={id} onRefresh={handleDocumentsRefresh} />,
    },
    {
      id: 4,
      title: "Taxes",
      content: (
        <Taxes id={id} account={account} onRefresh={handleDocumentsRefresh} />
      ),
    },
  ];

  return (
    <div className="mt-2">
      <div className="max-w-7xl mx-auto px-6 lg:px-0">
        <div className="grid grid-cols-3 gap-5">
          <div className="col-span-3 lg:col-span-2">
            <div className="card p-6">
              <ProfileHeading
                data={account}
                setData={setAccount}
                isLoading={isLoading}
              />
            </div>
            <ProfileTabs items={tabs} />
          </div>
          <div className="col-span-3 lg:col-span-1">
            <ProfileNavigation id={id} />
            <div className="card mt-3 p-0">
              <Others data={account} setData={setAccount} />
            </div>
            <div className="card mt-3 p-0">
              <IncomeInformation
                data={account}
                onRefresh={() => setRefresh(!refresh)}
              />
            </div>
            <div className="card mt-3 p-0">
              <Documents id={id} params={documentParams} />
            </div>
            <div className="card mt-3 p-0">
              <Identifications id={id} />
            </div>
            <div className="card mt-3 p-0">
              <AccountReferrals id={id} />
            </div>
            <div className="card mt-3 p-0">
              <Emails id={id} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
